import React, { Fragment, useEffect, useState } from 'react';
import { createSearchParams, useNavigate, useParams } from 'react-router-dom';
import { MarketplaceTemplatePreviewComponent } from './MarketplaceTemplatePreview.component';
import Layout from '../../../components/Layout';
import { useStateSelector } from '../../../store/selectors';
import { USER_ROLES } from '../../../utils/constants';
import { Breadcrumb, BreadcrumbItem, Card, CardBody } from 'reactstrap';
import { HomeButton } from '../../../components/HomeButton/home-button';
import { useDispatch } from 'react-redux';
import { GetTimelineById } from '../../../slices/marketplace/timeline/thunks/get-timeline-by-id.thunk';
import { resetCurrentTimeline } from '../../../slices/marketplace/timeline/timeline.slice';
import Helpers from '../../../utils/helper';
import { AdminMarketplaceTab } from '../../../slices/marketplace/timeline/models/enums/admin-marketplace-tab.enum';

interface TemplatePreviewProps {
    type: 'engagement' | 'template';
}

const MarketplaceTemplatePreview = (props: TemplatePreviewProps) => {
    const isTemplate = props.type === 'template';
    const userSummary = useStateSelector((state) => state.userSummary.summary);
    const dispatch = useDispatch() as any;
    const currentTimeline = useStateSelector(
        (state) => state.timelines.currentTimeline
    );
    const isAdmin = userSummary.roleId === USER_ROLES.ADMIN;
    const navigate = useNavigate();

    const templateId = useParams().id;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            if (templateId) {
                await fetchTimelineTemplate(Number(templateId));
            }
            setIsLoading(false);
        };
        init();
    }, [templateId]);

    const fetchTimelineTemplate = async (id: number) => {
        await dispatch(GetTimelineById({ id, isTemplate }));
    };

    const renderTimelinePreview = () => {
        return (
            <Fragment>
                <div className="cgm-admin-page timeline-editor marketplace-template-preview-chart">
                    <div>
                        <div className="main-title-content">
                            <div className="title-breadcrumb">
                                <div className="page-title">
                                    <h3>Timeline Preview</h3>
                                </div>
                                <Breadcrumb>
                                    <BreadcrumbItem>
                                        <HomeButton
                                            onClick={() => {
                                                dispatch(
                                                    resetCurrentTimeline()
                                                );
                                            }}
                                        />
                                    </BreadcrumbItem>
                                    <BreadcrumbItem active>
                                        <span
                                            className="breadcrumb-link"
                                            onClick={() => {
                                                dispatch(
                                                    resetCurrentTimeline()
                                                );
                                                navigate(`/marketplace/admin`);
                                            }}>
                                            Marketplace Admin Home
                                        </span>
                                    </BreadcrumbItem>
                                    <BreadcrumbItem active>
                                        Timeline Template Preview
                                    </BreadcrumbItem>
                                </Breadcrumb>
                            </div>
                        </div>
                    </div>

                    <Card className="card-section main-card mb-2 gantt-chart-container">
                        <CardBody className="gantt-chart-container">
                            <div
                                className="d-flex align-items-center justify-content-between"
                                style={{
                                    margin: '0 20px',
                                }}>
                                <div>
                                    <strong>{currentTimeline?.name ?? "NA"}</strong>
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        dispatch(resetCurrentTimeline());
                                        navigate({
                                            pathname: '/marketplace/admin',
                                            search: `?${createSearchParams({
                                                tab: Number(
                                                    AdminMarketplaceTab.TimelineTemplates
                                                ).toString(),
                                            })}`,
                                        });
                                    }}>
                                    Back
                                </button>
                            </div>
                            {isLoading ? (
                                <>{Helpers.renderTableLoader()}</>
                            ) : (
                                <MarketplaceTemplatePreviewComponent
                                    events={currentTimeline.events}
                                    displayCurrentDayIndicator={!isTemplate}
                                    onEventClick={() => {}}
                                />
                            )}
                        </CardBody>
                    </Card>
                </div>
            </Fragment>
        );
    };

    return (
        <Layout>
            {isAdmin ? (
                renderTimelinePreview()
            ) : (
                <h1>You don't have an access to see this page.</h1>
            )}
        </Layout>
    );
};

export default MarketplaceTemplatePreview;
